import React from 'react';
import {
  Box,
  Typography,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  Divider,
  Button,
  Paper
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  Description as DescriptionIcon,
  Gavel as GavelIcon,
  PrivacyTip as PrivacyTipIcon,
  Payment as PaymentIcon,
  ContactSupport as ContactSupportIcon,
  CheckCircle as CheckCircleIcon
} from '@mui/icons-material';
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  const sections = [
    {
      title: "Platform Overview",
      content:
        "E & J Global Realtors is an online real estate marketplace that enables users to list, discover, and connect for buying, selling, or renting properties. E & J Global Realtors acts solely as a technology facilitator and is not a party to any transaction between users.",
      items: [
        "Marketplace for residential, commercial, and land listings",
        "E & J Global Realtors does not own, sell, or broker properties",
        "Users must independently verify property details"
      ]
    },
    {
      title: "User Eligibility & Accounts",
      content:
        "By accessing or using E & J Global Realtors, you confirm that you are legally capable of entering into binding agreements and that all information provided by you is accurate and complete.",
      items: [
        "Users must be at least 18 years old",
        "Only one account per user unless approved",
        "Users are responsible for account security"
      ]
    },
    {
      title: "Listings & Property Information",
      content:
        "All property listings on E & J Global Realtors are user-generated. E & J Global Realtors does not verify ownership, legality, or accuracy of listings unless explicitly stated.",
      items: [
        "Images and descriptions are indicative only",
        "False or misleading listings are prohibited",
        "E & J Global Realtors may remove listings at its discretion"
      ]
    },
    {
      title: "Use of Platform",
      content:
        "Users agree to use E & J Global Realtors only for lawful real estate purposes and not engage in any fraudulent, misleading, or abusive activities.",
      items: [
        "No spam, scraping, or unauthorized promotions",
        "No misuse of contact details",
        "No impersonation or deceptive behavior"
      ]
    },
    {
      title: "Payments & Paid Services",
      content:
        "Certain features or services on E & J Global Realtors may be chargeable. Payments are processed through authorized third-party payment gateways.",
      items: [
        "Service fees are non-refundable unless stated",
        "Applicable taxes are borne by the user",
        "E & J Global Realtors is not a bank or escrow service"
      ]
    },
    {
      title: "Limitation of Liability",
      content:
        "E & J Global Realtors shall not be liable for any loss, damage, or dispute arising between users or from reliance on platform content.",
      items: [
        "No guarantee of transaction success",
        "No responsibility for third-party conduct",
        "Platform provided on an 'as-is' basis"
      ]
    }
  ];

  const quickLinks = [
    { text: "Privacy Policy", icon: <PrivacyTipIcon />, href: "/privacy-policy" },
    { text: "Payment Policy", icon: <PaymentIcon />, href: "/payment-policy" },
    { text: "Contact Support", icon: <ContactSupportIcon />, href: "/contact" }
  ];

  return (
    <Box sx={{ py: 8, minHeight: '100vh', backgroundColor: '#fafafa' }}>
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 6 },
            mb: 6,
            borderRadius: 4,
            backgroundColor: 'white',
            boxShadow: '0 8px 32px rgba(31, 38, 135, 0.05)'
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}
          >
            E & J Global Realtors – Terms & Conditions
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="body1" sx={{ mb: 4 }}>
            These Terms & Conditions govern your access to and use of the E & J Global Realtors
            platform, including property listings, communications between users,
            and any paid services. By using E & J Global Realtors, you agree to these terms.
          </Typography>



          {sections.map((section, index) => (
            <Box key={index} sx={{ mb: 6 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>

                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  {section.title}
                </Typography>
              </Box>

              <Typography variant="body1" sx={{ mb: 2 }}>
                {section.content}
              </Typography>

              <List dense>
                {section.items.map((item, i) => (
                  <ListItem key={i} sx={{ px: 0 }}>
                    {/* <ListItemIcon sx={{ minWidth: 30 }}>
                      <CheckCircleIcon color="primary" fontSize="small" />
                    </ListItemIcon> */}
                    <Typography variant="body2">{item}</Typography>
                  </ListItem>
                ))}
              </List>
            </Box>
          ))}

          <Accordion elevation={0} sx={{ border: '1px solid #ddd', mb: 4 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Governing Law & Jurisdiction</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                These Terms & Conditions shall be governed by the laws of India.
                Any disputes shall be subject to the exclusive jurisdiction of
                courts located in Tamil Nadu, India.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Box
            sx={{
              mt: 6,
              p: 4,
              borderRadius: 3,
              backgroundColor: 'rgba(63,81,181,0.05)'
            }}
          >
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
              Need Help?
            </Typography>
            <Typography sx={{ mb: 3 }}>
              Our support team is available to assist you with platform usage,
              listings, and general queries.
            </Typography>
            <Button
              component={Link}
              to="/contact"
              variant="contained"
              startIcon={<ContactSupportIcon />}
            >
              Contact Support
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
